import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Studio',
  description = 'Agentic AI data studio. Build and run visual pipeline DAGs, write SQL, PySpark and ThinkingLanguage scripts, stream with Kafka, and orchestrate multi-step AI workflows — all in one floating workspace.',
  keywords = 'agentic AI, data studio, pipeline flow editor, visual DAG, ETL, data pipeline, PySpark, ThinkingLanguage, Apache Kafka, Apache Spark, Apache Camel, SQL operations, AI workflow orchestration, data engineering, data science, real-time streaming',
  image = '/og-image.png',
  url = 'https://studio.thinkingdbx.com',
  type = 'website'
}) => {
  const fullTitle = title === 'Studio'
    ? 'Studio - Agentic AI Data Platform'
    : `${title} | Studio`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
